var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.415 0.920982C0.633951 1.70203 0.633165 2.96915 1.41421 3.7502L7.75578 10.0918C8.53683 10.8728 8.53683 12.1391 7.75579 12.9202L1.41421 19.2618C0.633163 20.0428 0.633951 21.3099 1.415 22.091C2.19605 22.872 3.46317 22.8728 4.24421 22.0918L13.4158 12.9202C14.1968 12.1391 14.1968 10.8728 13.4158 10.0918L4.24421 0.920197C3.46317 0.139147 2.19605 0.139935 1.415 0.920982Z","fill":"black"}));
}

Arrow.defaultProps = {"width":"14","height":"23","viewBox":"0 0 14 23","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
